"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const Monitoring_1 = __importDefault(require("./Monitoring"));
const AdminMonitoringPage = () => (react_1.default.createElement("div", { className: "admin" },
    react_1.default.createElement(Monitoring_1.default, null)));
exports.default = AdminMonitoringPage;
//# sourceMappingURL=AdminMonitoringPage.js.map